import React from 'react'
import { baseUrl } from 'utils/parseDomain'
import modalStyles from 'styles/modal.module.scss'

const SignTerms = () => {
  return (
    <p className={modalStyles.switcher}>
      By signing up, you agree to our{' '}
      <a
        href={`${baseUrl}/shaadi-info/index/terms`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms
      </a>
    </p>
  )
}

export default SignTerms
